module.exports = __webpack_public_path__ + "img/angle-down.4a0aa59c.svg";